// Dynamic URLs based on environment
// Works on both server and client side
// Supports: localhost, test.valbewust.nl, valbewust.nl

// Get URLs based on hostname (client-side) or env vars (server-side)
export function getBaseUrls(hostname?: string) {
  // If hostname is provided (from headers or window), use it
  if (hostname) {
    const protocol = hostname.includes('localhost') ? 'http:' : 'https:';

    // Local development
    if (hostname === 'localhost' || hostname.includes('localhost')) {
      const port = hostname.includes(':') ? hostname.split(':')[1] : '3001';
      return {
        consumer: `${protocol}//localhost:${port}`,
        zakelijk: `${protocol}//zakelijk.localhost:${port}`,
      };
    }

    // Test environment (test.valbewust.nl / test.zakelijk.valbewust.nl)
    if (hostname.startsWith('test.') || hostname.includes('.test.') || hostname.includes('test.zakelijk.')) {
      return {
        consumer: `${protocol}//test.valbewust.nl`,
        zakelijk: `${protocol}//test.zakelijk.valbewust.nl`,
      };
    }

    // Production (valbewust.nl / zakelijk.valbewust.nl)
    return {
      consumer: `${protocol}//valbewust.nl`,
      zakelijk: `${protocol}//zakelijk.valbewust.nl`,
    };
  }

  // Fallback: use environment variables (server-side without hostname)
  const isDev = process.env.NODE_ENV === 'development';
  if (isDev) {
    return {
      consumer: 'http://localhost:3001',
      zakelijk: 'http://zakelijk.localhost:3001',
    };
  }

  const siteDomain = process.env.SITE_DOMAIN || 'valbewust.nl';
  const zakelijkDomain = process.env.SITE_DOMAIN_ZAKELIJK || 'zakelijk.valbewust.nl';

  return {
    consumer: `https://${siteDomain}`,
    zakelijk: `https://${zakelijkDomain}`,
  };
}

// Client-side: detect from window.location
function getClientHostname(): string | undefined {
  if (typeof window !== 'undefined') {
    return window.location.host; // includes port
  }
  return undefined;
}

export function getConsumerUrl(path: string = '') {
  const urls = getBaseUrls(getClientHostname());
  return `${urls.consumer}${path}`;
}

export function getZakelijkUrl(path: string = '') {
  const urls = getBaseUrls(getClientHostname());
  return `${urls.zakelijk}${path}`;
}

// For server components: pass hostname from headers
export function getConsumerUrlFromHost(hostname: string, path: string = '') {
  const urls = getBaseUrls(hostname);
  return `${urls.consumer}${path}`;
}

export function getZakelijkUrlFromHost(hostname: string, path: string = '') {
  const urls = getBaseUrls(hostname);
  return `${urls.zakelijk}${path}`;
}
